import _ from 'lodash'
import moment from 'moment'
import { BACKEND_URL } from '../config'
import Icons from '../controllers/icons'
import Model from './model'
import TrackedGeolocation from './tracked-geolocation'

class GeolocationTracker extends Model {
  static get name() {
    return 'trackers'
  }

  static get url() {
    return `${BACKEND_URL}/tracking/devices`
  }

  static get parsers() {
    return {
      ...Model.parsers,
      locations: dataArray => TrackedGeolocation.many(dataArray, 'time')
    }
  }

  get latestLocation() {
    return _.last(this.locations)
  }

  get earliestLocation() {
    return _.first(this.locations)
  }

  get course() {
    return this.latestLocation != null ? this.latestLocation.course : undefined
  }

  get lastUpdateRelative() {
    return moment(this.lastUpdate).fromNow()
  }

  get lastSpeed() {
    return this.latestLocation != null ? this.latestLocation.speed : undefined
  }

  get lastBatteryPercent() {
    return this.latestLocation != null ? this.latestLocation.battery : undefined
  }

  get trajectory() {
    if (_.isEmpty(this.locations)) return []

    return [
      {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: this.locations.map(location => [
            location.latitude,
            location.longitude
          ])
        },
        properties: {}
      }
    ]
  }

  get latestLocationLayer() {
    if (!this.latestLocation) return []

    const marker = this.getRotatedMarker(
      this.latestLocation.coordinates,
      this.latestLocation.course
    )
      .bindPopup(
        `<center><a href=/trackers/${this.id}>${this.name}</a><br>${moment(
          this.latestLocation.time
        )
          .local()
          .format('HH:mm')}<br>${moment(this.latestLocation.time)
          .local()
          .format('DD.MM.YY')}<br>${this.latestLocation.calculatedSpeed}</center>`
      )
      .bindTooltip(`<a href=/trackers/${this.id}>${this.name}</a>`, {
        offset: L.point(0, -10),
        permanent: true,
        direction: 'top',
        opacity: 0.8,
        interactive: true
      })
    marker.setZIndexOffset(100)

    return marker
  }

  getRotatedMarker(coordinates, angle) {
    if (angle) {
      return L.marker([coordinates.latitude, coordinates.longitude], {
        icon: this.isOnline ? Icons.navigation_online : Icons.navigation_offline,
        rotationAngle: angle
      })
    }

    return L.marker([coordinates.latitude, coordinates.longitude], {
      icon: this.isOnline ? Icons.sennder_circle : Icons.gray_circle
    })
  }

  layers(selectedLocationIdx) {
    const SENNDER_LIGHT_ORANGE = '#ffb840'
    const GRAY = '#808080'
    const style = {
      color: this.isOnline ? SENNDER_LIGHT_ORANGE : GRAY,
      opacity: 1
    }

    const layersTrajectory = this.trajectory.map(t => L.geoJson(t.geometry, { style }))

    let stopN = 1
    let layersMarker = this.locations.slice(0, +-2 + 1).map(location => {
      stopN += 1
      return this.getRotatedMarker(location.coordinates, location.course).bindPopup(
        `<center>#${stopN}<br>${moment(location.time)
          .local()
          .format('HH:mm')}<br>${moment(location.time)
          .local()
          .format('DD.MM.YY')}<br>${location.calculatedSpeed}</center>`
      )
    })

    if (this.latestLocationLayer) {
      layersMarker = layersMarker.concat(this.latestLocationLayer)
    }

    if (selectedLocationIdx) {
      const location = this.locations[selectedLocationIdx]
      layersMarker.push(
        L.marker([location.coordinates.latitude, location.coordinates.longitude], {
          icon: Icons.blue_circle,
          zIndexOffset: 1000
        })
      )
    }

    return layersMarker.concat(layersTrajectory)
  }
}

export default GeolocationTracker
